import { DocumentType } from "@api/graphql/generated/generated-types";

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  [DocumentType.BackgroundCheck]: "Background Check",
  [DocumentType.CarInsurance]: "Car Insurance",
  [DocumentType.CommercialInsurance]: "Commercial Insurance",
  [DocumentType.CommercialVehicleInspection]: "Commercial Vehicle Inspection",
  [DocumentType.DriversLicense]: "Driver's License",
  [DocumentType.DrugTestResult]: "Drug Test Result",
  [DocumentType.HazmatCertification]: "Hazmat Certification",
  [DocumentType.HipaaCertification]: "HIPAA Certification",
  [DocumentType.BloodbornePathogenCertification]: "Bloodborne Pathogen (BBP) Certification",
  [DocumentType.MotorVehicleReport]: "Motor Vehicle Report",
  [DocumentType.ProofOfId]: "Proof of ID",
  [DocumentType.ProofOfWorkAuthorization]: "Proof of Work Authorization",
  [DocumentType.RefrigerationCertification]: "Refrigeration Certification",
  [DocumentType.SecurityClearance]: "Security Clearance",
  [DocumentType.TdgCertification]: "Transportation of Dangerous Goods",
  [DocumentType.Tsa]: "TSA",
  [DocumentType.VehicleRegistration]: "Vehicle Registration",
  [DocumentType.WorksafeCertification]: "WorkSafe Certification",
  [DocumentType.SexualHarassmentTraining]: "Sexual Harassment Training",
};
